export default __webpack_public_path__ + "static/media/bo.803556ae.svg";